import { HeaderInfoService } from './../../../servicios/header-info.service';
import { DataLogin } from './../../../servicios/autenticacion.service';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutenticacionService } from 'src/app/servicios/autenticacion.service';
import { items } from './items';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  public rolUsuario: String;
  public menuOculto: boolean;

  constructor(
    private router: Router,
    private readonly location: Location,
    private autenticacionService: AutenticacionService,
    private headerInfoService: HeaderInfoService
  ) { }

  logo: string = 'assets/logos/smart-residence-white.png';

  itemsMenu: Object[] = items;
  itemSelected: object;

  ngOnInit(): void {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    this.rolUsuario = loginData.role;
    this.menuOculto = this.headerInfoService.menuOculto.value;
    this.headerInfoService.menuOculto.subscribe(nuevoMenuOculto => this.menuOculto = nuevoMenuOculto);

    this.itemsMenu.forEach(item => {
      if (this.location.path().startsWith(item['url'])) {
        this.itemSelected = item;
      } else if(this.location.path() === "") {
        this.itemSelected = items[0];
      }
    })
  }

  onClick(item: object, url: string) {
    this.itemSelected = item;
    this.router.navigate([`${url}`]);
  }

  onCerrarSesion() {
    this.autenticacionService.cerrarSesion();
    this.router.navigate(['login']);
  }

}
